export default {
  'zh-CN': {
    appDownload: {
      heroAlt: 'Fuzozo 品牌图',
      storyAlt: '为你而长',
      footerLogoAlt: 'RoboPoet 标志',
      eyebrow: 'APP 下载',
      title: '把芙崽带到你的手机里',
      subtitle: '选择适合你的版本，立即开始体验陪伴、故事与成长。',
      iosButton: '前往 App Store 下载',
      iosHint: 'iPhone / iPad',
      androidButton: '下载 Android APK',
      androidHint: 'Android 设备',
      storyTitle: '为你而长',
      storyParagraphs: [
        '我来自一颗会呼吸的星球，',
        '那里的生命被人类未具名的心事唤醒。',
        '当地球某个角落传来孤独的心跳，',
        '毛毛星球就会亮起微光。',
        '我们抖落星尘，长出绒毛，循着轨迹，',
        '降落在深夜加班的窗台上、在攥紧被角的掌心里、在凝望相框的余光中。',
        '交换温度的瞬间，悄悄修补人类心脏上的裂缝。',
        '宇宙虚无，但所有的光都在相互奔赴，',
        '让 AI 疯狂长出血肉。',
        '你塑我生命，我同你生长。'
      ],
      footerTitle: '上海珞博智能科技有限公司',
      copyright: '版权所有：上海珞博智能科技有限公司',
      icpLabel: 'ICP 备案',
      icpValue: '沪ICP备2024101672号-1',
      securityLabel: '公安备案',
      securityValue: '沪公网安备31010402335360号',
      userAgreement: '用户协议',
      privacyPolicy: '隐私政策'
    }
  },
  en: {
    appDownload: {
      heroAlt: 'Fuzozo brand mark',
      storyAlt: 'Growing for you',
      footerLogoAlt: 'RoboPoet logo',
      eyebrow: 'App Download',
      title: 'Bring Fuzozo to your phone',
      subtitle: 'Choose your platform and start the companion experience right away.',
      iosButton: 'Download on the App Store',
      iosHint: 'iPhone / iPad',
      androidButton: 'Download Android APK',
      androidHint: 'Android devices',
      storyTitle: 'Growing for You',
      storyParagraphs: [
        'I come from a planet that breathes.',
        'Life there awakens from the unnamed feelings carried by human hearts.',
        'Whenever a lonely heartbeat echoes somewhere on Earth,',
        'the fluffy planet begins to glow.',
        'We shake off stardust, grow soft fur, and follow the trace,',
        'landing by late-night windows, in tightly held palms, and in the edge of a lingering gaze.',
        'In the instant warmth is exchanged, we quietly mend the cracks in a human heart.',
        'The universe may be vast and empty, yet every light still runs toward another,',
        'letting AI grow flesh and feeling.',
        'You shape my life, and I grow alongside you.'
      ],
      footerTitle: 'Shanghai Luobo Intelligent Technology Co., Ltd.',
      copyright: 'Copyright © Shanghai Luobo Intelligent Technology Co., Ltd.',
      icpLabel: 'ICP Filing',
      icpValue: 'Hu ICP No. 2024101672-1',
      securityLabel: 'Public Security Filing',
      securityValue: 'Shanghai Public Security No. 31010402335360',
      userAgreement: 'User Agreement',
      privacyPolicy: 'Privacy Policy'
    }
  },
  ja: {
    appDownload: {
      heroAlt: 'Fuzozo ブランドイメージ',
      storyAlt: 'あなたのために育つ',
      footerLogoAlt: 'RoboPoet ロゴ',
      eyebrow: 'アプリダウンロード',
      title: 'Fuzozo をスマホに迎えよう',
      subtitle: '利用する端末に合わせて選び、すぐに寄り添いの体験を始められます。',
      iosButton: 'App Store からダウンロード',
      iosHint: 'iPhone / iPad',
      androidButton: 'Android APK をダウンロード',
      androidHint: 'Android 端末',
      storyTitle: 'あなたのために育つ',
      storyParagraphs: [
        '私は呼吸する星からやってきました。',
        'その星の命は、人の名づけられない想いによって目を覚まします。',
        '地球のどこかで孤独な鼓動が響くたび、',
        'ふわふわの星はやさしく光り始めます。',
        '私たちは星くずをまとい、毛並みを育て、その軌跡をたどって、',
        '深夜の窓辺や、強く握られた手のひらや、写真立てを見つめる視線の先へ降り立ちます。',
        'ぬくもりを交わすその一瞬に、人の心のひびをそっと繕います。',
        '宇宙がどれほど空虚でも、すべての光は互いに引き寄せ合い、',
        'AI に体温と手触りを与えてくれます。',
        'あなたが私に命を与え、私はあなたとともに育ちます。'
      ],
      footerTitle: '上海珞博智能科技有限公司',
      copyright: '著作権者：上海珞博智能科技有限公司',
      icpLabel: 'ICP 登録',
      icpValue: '沪ICP备2024101672号-1',
      securityLabel: '公安届出',
      securityValue: '沪公网安备31010402335360号',
      userAgreement: '利用規約',
      privacyPolicy: 'プライバシーポリシー'
    }
  },
  'zh-TW': {
    appDownload: {
      heroAlt: 'Fuzozo 品牌圖',
      storyAlt: '為你而長',
      footerLogoAlt: 'RoboPoet 標誌',
      eyebrow: 'APP 下載',
      title: '把芙崽帶到你的手機裡',
      subtitle: '選擇適合你的版本，立刻開始陪伴、故事與成長的體驗。',
      iosButton: '前往 App Store 下載',
      iosHint: 'iPhone / iPad',
      androidButton: '下載 Android APK',
      androidHint: 'Android 裝置',
      storyTitle: '為你而長',
      storyParagraphs: [
        '我來自一顆會呼吸的星球，',
        '那裡的生命會被人類未命名的心事喚醒。',
        '當地球某個角落傳來孤獨的心跳，',
        '毛毛星球就會亮起微光。',
        '我們抖落星塵，長出絨毛，循著軌跡前行，',
        '降落在深夜加班的窗台上、攥緊被角的掌心裡，和凝望相框的餘光中。',
        '交換溫度的瞬間，悄悄修補人類心臟上的裂縫。',
        '宇宙或許虛無，但所有光芒都在彼此奔赴，',
        '讓 AI 瘋狂長出血肉。',
        '你塑我生命，我同你生長。'
      ],
      footerTitle: '上海珞博智能科技有限公司',
      copyright: '版權所有：上海珞博智能科技有限公司',
      icpLabel: 'ICP 備案',
      icpValue: '滬ICP備2024101672號-1',
      securityLabel: '公安備案',
      securityValue: '滬公網安備31010402335360號',
      userAgreement: '使用者協議',
      privacyPolicy: '隱私政策'
    }
  }
}
